import React,{useEffect, useState} from "react";
import { UNSUBSCRIBERS_LINK } from "../../../constants/constants";
import client from "../../../api";
import { notifyError, notifySuccess } from "../../../helper";

const SubscribeDomainModelWindow = (props) => {
    const { setShowModelWindow, showModelWindow, selectedRecipient } = props;
    const api = client();    
    const [loading, setLoading] = useState(false);
    const [domains,setDomains]=useState([]);
    const handleCheckBoxChange = (domain) => {
        const updatedItems = domains.map(item =>
            item.domain === domain ? { ...item, isChecked: !item.isChecked } : item
          );
          setDomains(updatedItems);
    }

    const handleDeleteDomains = async () => {
        const selectedDomains = domains.filter(item => item.isChecked).map(item => item.domain);
        if(!selectedDomains.length){
            notifyError('No domain is selected');
            return;
        }
        try {
            setLoading(true);
            const payload = {
                email_list:[selectedRecipient.email],
                domains: selectedDomains
            }
            
            const response = await api.post("/v1/contact/unsubscribes/domains/delete",payload);

            if(response.status === 200 || response.status === 201){
                notifySuccess("Selected Domain(s) are deleted from the recipient's record");
                setTimeout(()=>{
                    window.location.href = UNSUBSCRIBERS_LINK;
                },1500);
            }

        } catch (error){
            setLoading(false);
            if(error.status === 400) { notifyError("Bad request. Unable to delete selected domains from the recipient's record"); }
        } finally {
            setLoading(false);
        }

    }
    useEffect(()=>{
        const addCheckedStatus = (data) => {
            const updatedDomains = data.map((v,i)=>({...v,isChecked:false}));
            setDomains(updatedDomains);
        }
        addCheckedStatus(selectedRecipient.unsubscribes);
    },[selectedRecipient]);
    
    return(<>
        <div className="model-window">
            <div className="overlay"></div>
            <div className="model-view">
                <div className="inner-view">
                    <h2>Delete Domain(s)</h2>
                    <p>The following domains will be deleted for this recipient. The domains will be allowed to recieve the email:</p>
                    <ul className="domain-list">
                        {domains.length && domains.map((domain,index)=>(
                            <li key={index}>
                                <div className="checkbox-style">
                                    <label>
                                        <input type="checkbox" onChange={()=>handleCheckBoxChange(domain.domain)} checked={domain.isChecked} /> 
                                        <span className="checkbox"></span>
                                    </label>
                                </div>                                
                                <span className="domain-name">{domain.domain}</span>
                            </li>
                        ))}                        
                    </ul>
                    <div className="button-group">
                        <button 
                            type="button" 
                            className={loading ? "delete-btn button--loading":"delete-btn"} 
                            disabled={loading}
                            onClick={()=>{handleDeleteDomains()}}>
                                <span className="button--text">Delete</span>
                        </button>                        
                        <button className="cancel-btn" onClick={()=>setShowModelWindow(!showModelWindow)}>Cancel</button>
                    </div>
                </div>
            </div>
        </div>
    </>);
}

export default SubscribeDomainModelWindow;